import { useEffect, useState } from 'react'
import { Alert, Button, CircularProgress, Container, Paper, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import sessionStore from '../stores/sessionStore'
import { authErrorMessage } from '../auth/authErrors'

export default function VerifyEmail() {
	const navigate = useNavigate()
	const [token] = useState(() => new URLSearchParams(window.location.search).get('token'))
	const [state, setState] = useState('loading')
	const [error, setError] = useState('')

	useEffect(() => {
		window.history.replaceState({}, '', '/verify-email')
		if (!token) {
			setError('Ссылка подтверждения не содержит токен.')
			setState('error')
			return
		}
		sessionStore.verifyEmail(token)
			.then(() => setState('success'))
			.catch(reason => { setError(authErrorMessage(reason)); setState('error') })
	}, [token])

	return <Container maxWidth='xs'><Paper sx={{ p: 3, mt: 5 }}>
		<Typography variant='h5' gutterBottom>Подтверждение электронной почты</Typography>
		{state === 'loading' && <CircularProgress />}
		{state === 'success' && <Alert severity='success'>Электронная почта подтверждена. Теперь можно войти.</Alert>}
		{state === 'error' && <Alert severity='error'>{error}</Alert>}
		{state !== 'loading' && <Button sx={{ mt: 2 }} onClick={() => navigate('/login')}>Перейти ко входу</Button>}
	</Paper></Container>
}
